/**
 * Created by galweissman on 17/05/2016.
 */
import app from 'app';
import Marionette from 'backbone.marionette';

app.namespace.View.InfogfxWebpageView = Marionette.ItemView.extend({
  className: 'wt-infogfx-webpage',
  id: 'infogfxWebpageView',
  ui: {
    url: '.js-url',
    error: '.js-webpage-error',
  },
  behaviors: {},

  events: {
    'keydown @ui.url': '_keyDown',
  },

  initialize: function () {
    this.template = app.compileTemplate.$('#infogfx-modal-webpage');
  },

  onShow: function () {
    this.ui.url.on(
      'blur',
      function () {
        this._isValidUrl(this.ui.url.val());
      }.bind(this)
    );
  },

  onBeforeDestroy: function () {},

  _keyDown: function () {
    this.ui.error.removeClass('wt-visible');
  },

  _isValidDomain(url) {
    const isSubdomain = /\.wochit\.com/i.test(url);
    const allowedDomains = /^(http[s]?:\/\/)?(www\.)?wochit\.com/i.test(url);
    return !isSubdomain || allowedDomains;
  },

  _isValidUrl: function (url) {
    if (app.validate.url(url) && this._isValidDomain(url)) {
      this.ui.error.removeClass('wt-visible');
      return true;
    } else {
      this.ui.error.addClass('wt-visible');
      return false;
    }
  },

  isDirty: function () {
    return !_.isEmpty(this.ui.url.val());
  },

  serialize: function () {
    const url = this.ui.url.val();
    if (!this._isValidUrl(url)) {
      return false;
    } else {
      return {
        assetType: app.assetType.WEBPAGE,
        path: 'webpages',
        taskModel: {
          data: {
            url: encodeURI(url),
          },
          caption: (url.indexOf('http') == -1 ? '//' : '') + url,
          title: url,
        },
      };
    }
  },
});

export default app.namespace.View.InfogfxWebpageView;
